<template>
  <div class="bs-wrapper imgFather" :style="{ height: stageHeight + 'px' }">
<!--    <div class='wxImgBox' id='wx_pic'>-->
<!--      <img :src='require("../../assets/logo.png")'>-->
<!--    </div>-->
    <!-- 后台编辑的定制活动 -->
    <div class="activity-wrapper" v-show="show">
      <div class="section3 flex-col">
        <div class="main1 flex-col">
          <div class="main2 flex-col">
            <div class="section4 flex-col">
              <van-image class="head-img" :src="picture" />
            </div>
          </div>
          <div class="main3 flex-row">
            <span class="word3">活动名称</span>
            <span class="info3">{{ name }}</span>
          </div>
          <div class="main3 flex-row">
            <span class="word3">活动时间</span>
            <span class="info3">{{ startTime }}&nbsp;~&nbsp;{{ endTime }}</span>
          </div>
          <div class="main3 flex-row">
            <span class="word3">活动地点</span>
            <span class="info3">{{ address }}</span>
          </div>
          <div class="main6 flex-row">
            <span class="word7">活动详情</span>
            <span class="word8" v-html="detail"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Image, Toast } from 'vant';
import { mapState } from 'vuex';

import { getInsideDetail } from '@/api/activity';

export default {
  name: 'plazaActivityInsideDetail',

  mixins: [],

  components: {
    [Image.name]: Image,
  },

  props: {},

  data() {
    return {
      id: 1,
      // 活动名称
      name: '',
      // 活动详情
      detail: '',
      // 开始时间
      startTime: '',
      // 结束时间
      endTime: '',
      // 活动头图
      picture: '',
      // 活动链接
      link: '',
      // 活动地址
      address: '',
      show: false,
      NATIVE_SHARE_TYPE: 'PlazaActivityShare',
    };
  },

  computed: {
    ...mapState({
      stageHeight: state => state.base.stageHeight,
    }),
  },

  watch: {
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (!newVal) return;
          this.init();
        }
      },
    },
  },

  created() {

    this.init();
  },

  mounted() {},

  destroyed() {},

  methods: {
    async init() {
      try {
        let res = await getInsideDetail({
          id: this.$route.params.id,
        });
        (this.id = res.id),
          // 活动名称
          (this.name = res.name),
          // 活动详情
          (this.detail = res.detail);
        // 开始时间
        this.startTime = String(res.startTime).slice(0, 16);
        // 结束时间
        this.endTime = String(res.endTime).slice(0, 16);
        // 活动头图
        this.picture = res.picture;
        // 活动地址
        this.address = res.address || '';

        document.title = this.name;

        // console.log(res)
      } catch (error) {
        Toast({
          message: error.message || '获取活动详情失败',
          duration: 1000,
          position: 'top',
        });
      }
      this.show = true;
    },

    initialShare() {
      this.$bsUtils.nativeApi.isShowOrHiddenRightBtn({
        isShow: '1',
        rightBtnType: this.NATIVE_SHARE_TYPE,
      });

      window.onRightBtnEvent = (isSuccess, data) => {
        console.log('onRightBtnEvent: ', isSuccess, data); // eslint-disable-line no-console
        data = typeof data === 'string' ? JSON.parse(data) : data;
        if (isSuccess === 'true' || isSuccess) {
          switch (data.rightBtnType) {
          case this.NATIVE_SHARE_TYPE:
            this.$bsUtils.nativeApi.shareMessage({
              title: this.name,
              description: this.detail,
              shareType: 2,
              sceneList: [0],
              webpageUrl: window.location.href
            });
            break;
          }
        }
      }
    },
  },
  beforeRouteEnter(t, f, next) {
    next(vm => {
      vm.initialShare();
    })
  },
};
</script>

<style lang="less" scoped>
.bs-wrapper {
  width: 100%;
  padding-top: 10px;
  max-height: calc(100% - 74px);
  overflow: auto;
}
.activity-wrapper {
  //margin-left: 10px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 74px;
}
.section3 {
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
  align-self: center;
  width: 100%;
  box-sizing: border-box;
  justify-content: flex-start;
  padding-top: 16px;
  padding-bottom: 40px;
  align-items: center;
  .main1 {
    width: 95%;
    align-items: center;
    // height: 439px;
    .main2 {
      position: relative;
      width: 100%;
      height: 163px;
      border-radius: 8px;
      overflow: hidden;
      .section4 {
        height: 163px;
        width: 100%;
        justify-content: flex-end;
        align-items: flex-start;
        position: absolute;
        left: 0;
        top: 0;
      }
      .head-img {
        display: block;
        width: 100%;
        height: 163px;
        background: #d8d8d8;
        border-radius: 8px;
        overflow: hidden;
      }
    }
    .main3 {
      width: 100%;
      margin-top: 20px;
      justify-content: flex-start;
      .word3 {
        width: 56px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 20px;
        text-align: right;
      }
      .info3 {
        flex: 1;
        overflow-wrap: break-word;
        word-break: break-all;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        line-height: 20px;
        text-align: left;
        padding-left: 12px;
      }
    }
    .main6 {
      width: 100%;
      // height: 160px;
      margin-top: 12px;
      justify-content: space-between;
      .word7 {
        width: 56px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 20px;
        text-align: left;
      }
      .word8 {
        flex: 1;
        margin-left: 8px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.section5 {
  position: fixed;
  bottom: 0px;
  height: 44px;
  border-radius: 22px;
  box-shadow: 0px 3px 12px 1px rgba(228, 19, 53, 0.35);
  background: #FF6F00;
  align-self: center;
  margin-left: 10px;
  margin-top: 38px;
  width: 355px;
  justify-content: center;
  align-items: center;
  .word9 {
    z-index: 48;
    width: 64px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 22px;
    text-align: center;
  }
}
.iframeContain {
  height: calc(100% - 8px);
  overflow: auto;
  iframe {
    width: 355px;
    border: none;
    height: calc(100% - 28px);
  }
}

.imgFather {
  position: relative;
  .wxImgBox {
    position: absolute;
    display: none;
  }
}

</style>
